(function () {
    'use strict';

    angular.module("imApp").factory("componentsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 722,
                    parameters: parms || {}
                });
            },
            listComponents: function (parms) {
                return $ihttp.post({
                    method: 706,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
